import { createAction, props } from '@ngrx/store';
import { RecruiterGrouping } from 'src/app/lead-queue/models/recruiter-grouping.model';
import { ProfessionGroup } from 'src/app/lead-queue/models/recruiter-lead-Info.model';
import { Expertise } from 'src/app/shared/models/expertise.model';
import { ProfessionGroupRecruiter } from '../../models/profession-group-recruiter.model';
import { RecruiterPauseStatus } from '../../models/recruiter-pause-status.model';

export const loadRecruiterGrouping = createAction('[LEAD QUEUE PERMISSIONS COMPONENT] Load Recruiter Grouping');
export const loadRecruiterGroupingSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Load Recruiter Grouping Successfully',
    props<{ grouping: RecruiterGrouping }>()
);
export const loadRecruiterGroupingFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Load Recruiter Grouping Failure',
    props<{ error: unknown }>()
);

export const createProfessionGroup = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Create Profession Group',
    props<{ name: string; parentGroupId: number }>()
);
export const createProfessionGroupSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Create Profession Group Successfully',
    props<{ result: ProfessionGroup }>()
);
export const createProfessionGroupFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Create Profession Group Failure',
    props<{ error: unknown }>()
);

export const loadProfessionGroupAssignedRecruiters = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Load Profession Group Assigned Recruiters',
    props<{ professionGroupId: number }>()
);
export const loadProfessionGroupAssignedRecruitersSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Load Profession Group Assigned Recruiters Successfully',
    props<{ professionGroupRecruiters: ProfessionGroupRecruiter[] }>()
);
export const loadProfessionGroupAssignedRecruitersFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Load Profession Group Assigned Recruiters Failure',
    props<{ error: unknown }>()
);

export const loadProfessionGroupIdsWithPausedRecruiters = createAction(
    '[LEAD QUEUE PERMISSIONS COMPONENT] Load Profession Group Ids With Paused Recruiters'
);
export const loadProfessionGroupIdsWithPausedRecruitersSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Load Profession Group Ids With Paused Recruiters Successfully',
    props<{ professionGroupIdsWithPausedRecruiters: number[] }>()
);
export const loadProfessionGroupIdsWithPausedRecruitersFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Load Profession Group Ids With Paused Recruiters Failure',
    props<{ error: unknown }>()
);

export const updateProfessionGroupPauseStatuses = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Update Profession Group Pause Statuses',
    props<{ professionGroupId: number; recruiterPauseStatuses: RecruiterPauseStatus[] }>()
);
export const updateProfessionGroupPauseStatusesSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Pause Statuses Successfully',
    props<{ result: number }>()
);
export const updateProfessionGroupPauseStatusesFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Pause Statuses Failure',
    props<{ error: unknown }>()
);

export const updateProfessionGroup = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Update Profession Group',
    props<{ name: string; professionGroupId: number }>()
);
export const updateProfessionGroupSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Successfully',
    props<{ result: ProfessionGroup }>()
);
export const updateProfessionGroupFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Failure',
    props<{ error: unknown }>()
);

export const deleteProfessionGroup = createAction(
    '[LEAD QUEUE PERMISSIONS COMPONENT] Delete Profession Group By Group Id',
    props<{ groupId: number }>()
);
export const deleteProfessionGroupSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Delete Profession Group Successfully'
);
export const deleteProfessionGroupFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Delete Profession Group Failure',
    props<{ error: unknown }>()
);

export const updateProfessionGroupProfession = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Update Profession Group Profession',
    props<{ professionGroupId: number; professionId: number }>()
);
export const updateProfessionGroupProfessionSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Profession Success'
);
export const updateProfessionGroupProfessionFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Profession Failure',
    props<{ error: unknown }>()
);

export const deleteProfessionGroupProfession = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Delete Profession Group Profession',
    props<{ professionGroupId: number; professionId: number }>()
);
export const deleteProfessionGroupProfessionSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Delete Profession Group Profession Success'
);
export const deleteProfessionGroupProfessionFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Delete Profession Group Profession Failure',
    props<{ error: unknown }>()
);

export const updateProfessionGroupProfessionSpecialty = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Update Profession Group Profession Specialty',
    props<{ professionGroupId: number; professionId: number; expertiseId: number }>()
);
export const updateProfessionGroupProfessionSpecialtySuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Profession Specialty Success'
);
export const updateProfessionGroupProfessionSpecialtyFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Update Profession Group Profession Specialty Failure',
    props<{ error: unknown }>()
);

export const deleteProfessionGroupProfessionSpecialty = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Delete Profession Group Profession Specialty',
    props<{ professionGroupId: number; professionId: number; expertiseId: number }>()
);
export const deleteProfessionGroupProfessionSpecialtySuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Delete Profession Group Profession Specialty Success'
);
export const deleteProfessionGroupProfessionSpecialtyFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Delete Profession Group Profession Specialty Failure',
    props<{ error: unknown }>()
);

export const loadExpertisesByProfIds = createAction(
    '[PROFESSION GROUP DIALOG COMPONENT] Load Expertises By Profession Ids',
    props<{ professionIds: number[] }>()
);
export const loadExpertisesByProfIdsSuccessfully = createAction(
    '[LOOKUP PROFESSIONS API] Load Expertises By Profession Ids Successfully',
    props<{ expertises: Expertise[] }>()
);
export const loadExpertisesByProfIdsFailure = createAction(
    '[LOOKUP PROFESSIONS API] Load Expertises By Profession Ids Failure',
    props<{ error: unknown }>()
);

export const resetLeadQueueExpertises = createAction('[PROFESSION GROUP DIALOG COMPONENT] Reset Expertises');

export const assignRecruiterToLocation = createAction(
    '[RECRUITER DRAG DROP COMPONENT] Assign Recruiter to Location',
    props<{ recruiterId: number; locationId: number }>()
);
export const assignRecruiterToLocationSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Assign Recruiter to Location Successfully'
);
export const assignRecruiterToLocationFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Assign Recruiter to Location Failure',
    props<{ error: unknown }>()
);

export const unassignRecruiterFromLocation = createAction(
    '[RECRUITER DRAG DROP COMPONENT] Unassign Recruiter to Location',
    props<{ recruiterId: number; locationId: number }>()
);
export const unassignRecruiterFromLocationSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Unassign Recruiter to Location Successfully'
);
export const unassignRecruiterFromLocationFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Unassign Recruiter to Location Failure',
    props<{ error: unknown }>()
);

export const assignRecruiterToGroup = createAction(
    '[RECRUITER DRAG DROP COMPONENT] Assign Recruiter to Group',
    props<{ recruiterId: number; professionGroupId: number }>()
);
export const assignRecruiterToGroupSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Assign Recruiter to Group Successfully'
);
export const assignRecruiterToGroupFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Assign Recruiter to Group Failure',
    props<{ error: unknown }>()
);

export const unassignRecruiterFromGroup = createAction(
    '[RECRUITER DRAG DROP COMPONENT] Unassign Recruiter to Group',
    props<{ recruiterId: number; professionGroupId: number }>()
);
export const unassignRecruiterFromGroupSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Unassign Recruiter from Group Successfully'
);
export const unassignRecruiterFromGroupFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Unassign Recruiter from Group Failure',
    props<{ error: unknown }>()
);

export const setRecruiterActive = createAction(
    '[MANAGE RECRUITER STATUS DIALOG COMPONENT] Set Recruiter Active',
    props<{ recruiterId: number; status: number }>()
);
export const setRecruiterActiveSuccessfully = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Set Recruiter Active Successfully'
);
export const setRecruiterActiveFailure = createAction(
    '[LEAD QUEUE ASSIGNMENT API] Set Recruiter Active Failure',
    props<{ error: unknown }>()
);

export const setRecruiterLeadQueueToggle = createAction(
    '[MANAGE RECRUITER LEAD QUEUE TOGGLE DIALOG COMPONENT] Set Recruiter Lead Queue Toggle',
    props<{ id: number; leadQueueToggleAvailable: boolean }>()
);

export const setRecruiterLeadQueueToggleSuccessfully = createAction(
    '[MANAGE RECRUITER LEAD QUEUE TOGGLE DIALOG COMPONENT] Set Recruiter Lead Queue Toggle Successfully'
);

export const setRecruiterLeadQueueToggleFailure = createAction(
    '[MANAGE RECRUITER LEAD QUEUE TOGGLE DIALOG COMPONENT] Set Recruiter Lead Queue Toggle Failure',
    props<{ error: unknown }>()
);

export const setRecruiterLineOfBusiness = createAction(
    '[MANAGE RECRUITER LINE OF BUSINESS DIALOG COMPONENT] Set Recruiter Line Of Business',
    props<{ recruiterLeadInfoId: number; lineOfBusinessId: number; isTrue: boolean }>()
);

export const setRecruiterLineOfBusinessSuccessfully = createAction(
    '[MANAGE RECRUITER LINE OF BUSINESS DIALOG COMPONENT] Set Recruiter Line Of Business Successfully'
);

export const setRecruiterLineOfBusinessFailure = createAction(
    '[MANAGE RECRUITER LINE OF BUSINESS DIALOG COMPONENT] Set Recruiter Lead Queue Toggle Failure',
    props<{ error: unknown }>()
);
